var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-whiteboard-slide audio_block h-100 w-100 d-flex justify-content-center align-items-center"},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.blockData.audioUrl,"type":"audio/mpeg"}}),_vm._v(" Your browser does not support the audio element. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }